export enum NetworkTabs {
  CUSTOMERS = "customers",
  SUPPLIERS = "suppliers",
  AGENTS = "agents",
  CARRIES = "carries",
  ACCOUNTS = "accounts",
}
